"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import type { ReactNode } from "react";
import { FaChevronDown } from "react-icons/fa";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible";
import { useUser } from "@/contexts/user-provider";
import { cx } from "@/lib/tailwind-utils";
import { useChartSectionCollapseStore } from "@/stores/chart-section-collapse-store";
interface CollapsibleSectionProps {
  title: string;
  id?: string;
  defaultOpen?: boolean;
  persistKey?: string;
  headerControls?: ReactNode;
  actions?: ReactNode;
  children: ReactNode;
  className?: string;
  /** Rule under the header; off for sections stacked as a plain list. */
  divider?: boolean;
}
export default function CollapsibleSection(t0) {
  const $ = _c(39);
  const {
    title,
    id,
    defaultOpen: t1,
    persistKey,
    headerControls,
    actions,
    children,
    className,
    divider: t2
  } = t0;
  const defaultOpen = t1 === undefined ? true : t1;
  const divider = t2 === undefined ? true : t2;
  const {
    currentUser
  } = useUser();
  const providerId = currentUser?.id;
  const isPersisted = !!persistKey && !!providerId;
  let t3;
  if ($[0] !== isPersisted || $[1] !== persistKey || $[2] !== providerId) {
    t3 = s => isPersisted ? s.collapsedByProvider[providerId]?.[persistKey] : undefined;
    $[0] = isPersisted;
    $[1] = persistKey;
    $[2] = providerId;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const persistedCollapsed = useChartSectionCollapseStore(t3);
  const setCollapsed = useChartSectionCollapseStore(_temp);
  const [localOpen, setLocalOpen] = useState(defaultOpen);
  const open = isPersisted ? !(persistedCollapsed ?? !defaultOpen) : localOpen;
  let t4;
  if ($[4] !== isPersisted || $[5] !== persistKey || $[6] !== providerId || $[7] !== setCollapsed) {
    t4 = next => {
      if (isPersisted) {
        setCollapsed(providerId, persistKey, !next);
      } else {
        setLocalOpen(next);
      }
    };
    $[4] = isPersisted;
    $[5] = persistKey;
    $[6] = providerId;
    $[7] = setCollapsed;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const handleOpenChange = t4;
  const t5 = divider && "border-b pb-2";
  let t6;
  if ($[9] !== t5) {
    t6 = cx("mb-4 flex items-center justify-between gap-3", t5);
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const t7 = !open && "-rotate-90";
  let t8;
  if ($[11] !== t7) {
    t8 = cx("size-3 shrink-0 text-foreground-muted transition-transform duration-150", t7);
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t8) {
    t9 = <FaChevronDown className={t8} aria-hidden="true" />;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== title) {
    t10 = <span className="truncate">{title}</span>;
    $[15] = title;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== open || $[18] !== t10 || $[19] !== t9) {
    t11 = <h3 className="min-w-0 text-body-emphasis text-foreground"><CollapsibleTrigger asChild={true}><button type="button" aria-expanded={open} className="group flex min-w-0 items-center gap-2 rounded outline-none focus-visible:ring-2 focus-visible:ring-primary">{t9}{t10}</button></CollapsibleTrigger></h3>;
    $[17] = open;
    $[18] = t10;
    $[19] = t9;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== headerControls || $[22] !== t11) {
    t12 = <div className="flex min-w-0 items-center gap-3">{t11}{headerControls}</div>;
    $[21] = headerControls;
    $[22] = t11;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== actions) {
    t13 = actions && <div className="flex items-center gap-2">{actions}</div>;
    $[24] = actions;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t12 || $[27] !== t13 || $[28] !== t6) {
    t14 = <div className={t6}>{t12}{t13}</div>;
    $[26] = t12;
    $[27] = t13;
    $[28] = t6;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== children) {
    t15 = <CollapsibleContent>{children}</CollapsibleContent>;
    $[30] = children;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== className || $[33] !== handleOpenChange || $[34] !== id || $[35] !== open || $[36] !== t14 || $[37] !== t15) {
    t16 = <Collapsible open={open} onOpenChange={handleOpenChange} id={id} className={className}>{t14}{t15}</Collapsible>;
    $[32] = className;
    $[33] = handleOpenChange;
    $[34] = id;
    $[35] = open;
    $[36] = t14;
    $[37] = t15;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  return t16;
}
function _temp(s_0) {
  return s_0.setCollapsed;
}